import request from "@/utils/request";
import qs from "qs";

/**
 * 查询店铺
 * @param params
 * @returns {*}
 */
export function getStoreList(params) {
  return request({
    url: "/shop/getList",
    method: "get",
    params
  });
}

/**
 * 新增-编辑店铺
 * @param params
 * @returns {*}
 */
export function editShop(params) {
    return request.post("/shop/editShop", qs.stringify(params));
}

/**
 * 审核店铺
 * @param params
 * @returns {*}
 */
export function checkShop(params) {
    return request.post("/shop/checkShop", qs.stringify(params));
}


/**
 * 查询我的店铺列表 用于商品管理里面选择店铺
 * @param params
 * @returns {*}
 */
export function getMyList(params) {
    return request({
        url: "/shop/getMyList",
        method: "get",
        params
    });
}

// =======================================变更店铺 start========================================================

/**
 * 查询店铺变更列表
 * @param params
 * @returns {*}
 */
export function getShopchangeList(params) {
    return request({
        url: "/shopchange/getList",
        method: "get",
        params
    });
}
/**
 * 审核店铺变更
 * @param params
 * @returns {*}
 */
export function checkShopChange(params) {
    return request.post("/shopchange/checkShopChange", qs.stringify(params));
}

// =======================================变更店铺 end========================================================


// =======================================运费模版 start========================================================
/**
 * 新增-编辑运费模板
 * @param params
 * @returns {*}
 */
export function editPostages(params) {
    return request.post("/postages/editPostages", qs.stringify(params));
}
/**
 * 查询运费模板列表
 * @param params
 * @returns {*}
 */
export function getPostagesList(params) {
    return request({
        url: "/postages/getList",
        method: "get",
        params
    });
}

export function getCascadeRegion(params) {
    return request({
        url: "/region/getCascadeRegion",
        method: "get",
        params
    });
}

// =======================================运费模版 end========================================================
